import type {QuizQuestion} from "./types";

// Default quiz data — swap this array to create new quiz episodes
export const QUESTIONS_DATA: QuizQuestion[] = [
  {
    category: "CRESCIMENTO",
    text: "Voce fatura R$100k/mes mas o lucro liquido nao passa de R$8k. Onde esta o problema?",
    options: [
      "Precisa faturar mais",
      "O CAC esta comendo a margem",
      "Falta de branding",
      "Precisa de mais trafego",
    ],
    correctIndex: 1,
  },
  {
    category: "ESTRATEGIA",
    text: "Seu melhor vendedor pediu demissao. O faturamento caiu 40%. O que isso revela?",
    options: [
      "Que ele era bom demais",
      "Que faltou contraproposta",
      "Que voce nao tem sistema de vendas",
      "Que precisa contratar rapido",
    ],
    correctIndex: 2,
  },
  {
    category: "MARKETING",
    text: "Sua agencia entregou 500 leads no mes. Mas so 3 viraram venda. O que voce analisa PRIMEIRO?",
    options: [
      "Trocar a agencia",
      "Qualificacao do lead no funil",
      "Aumentar o orcamento",
      "Mudar o criativo do anuncio",
    ],
    correctIndex: 1,
  },
  {
    category: "DECISAO",
    text: "Dois canais de aquisicao: um traz lead a R$12 mas converte 1%. Outro traz a R$45 mas converte 8%. Qual escalar?",
    options: [
      "O de R$12 porque e mais barato",
      "Os dois ao mesmo tempo",
      "O de R$45 porque o custo por venda e menor",
      "Nenhum sem antes testar mais",
    ],
    correctIndex: 2,
  },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
